'use client';

import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';

import { getTaskStatus } from '@/lib/admin/client';
import { taskStatusQueryKey } from '@/lib/admin/queryKeys';

export function useTaskStatus(originUrl: string | null) {
  const { getToken, isLoaded, isSignedIn, sessionId, userId } = useAuth();
  const ready = isLoaded && !!isSignedIn && !!userId && !!sessionId;

  return useQuery({
    queryKey: taskStatusQueryKey({ userId, sessionId }, originUrl),
    enabled: ready,
    retry: false,
    queryFn: async () => {
      const token = await getToken();
      if (!token) throw new Error('Missing auth token');
      return getTaskStatus(token, originUrl ?? undefined);
    },
  });
}
